<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      :customRow="selectUser"
    >
    </a-table>
    <MessageList :visible="visible" />
  </div>
</template>

<script>
const Parse = require("parse");
import MessageList from "../../components/dashboard/conversation/Conversation";

export default {
  components: { MessageList },
  data() {
    return {
      visible: false,
      pagination: {},
      loading: false,
      columns: [
        {
          title: "User",
          dataIndex: "id",
          width: "20%",
        },
      ],
      data: [],
    };
  },
  mounted() {
    this.asyncData();
  },
  methods: {
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      console.log("showDrawer");
      this.visible = true;
    },
    onClose() {
      console.log("onClose");

      this.visible = false;
    },
    async asyncData() {
      this.loading = true;
      const result = await Parse.Cloud.run("fetchConversation", {
        teamId: "3avoDlG3BE",
      });
      const pagination = { ...this.pagination };
      pagination.total = result.length;
      this.loading = false;
      this.data = result;
      this.pagination = pagination;
      let query = new Parse.Query("Conversation");
      let subscription = await query.subscribe();
      subscription.on("create", (object) => {
        this.data.push(object.id);
        console.log(object.id);
      });
    },
    selectUser(record) {
      return {
        on: {
          click: async () => {
            console.log(record);
            this.showDrawer();
          },
          dblclick: () => {},
        },
      };
    },
  },
};
</script>

<style>
</style>